module.exports = __webpack_public_path__ + "static/blockchainHero-f4dc9dbb9cf2462460888314ec329da5.png";